import React, { useEffect, useState } from 'react';
import Masonry from '@mui/lab/Masonry';

function Gallery() {
  const [feeds, setFeeds] = useState([]);
  const [isStarted, setIsStarted] = useState(false);
  const ACCESS_TOKEN = process.env.REACT_APP_INSTA_TOKEN;

  useEffect(() => {
    const fetchFeeds = async () => {
      const url = `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url&limit=18&access_token=${ACCESS_TOKEN}`;
      try {
        const response = await fetch(url);
        const result = await response.json();
        if (result.data) {
          setFeeds(result.data);
          // 모든 데이터를 가져온 후 1.2초 뒤 등장 시작
          setTimeout(() => setIsStarted(true), 1200);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    if (ACCESS_TOKEN) fetchFeeds();
  }, [ACCESS_TOKEN]);

  return (
    <section className="section">
      <div className="masonry-wrap">
        {feeds.length > 0 && (
          <Masonry columns={{ xs: 2, sm: 3, lg: 4 }} spacing= {{ xs: 1, sm: 1, lg: 2 }}>
            {feeds.map((item, index) => (
              <div 
                key={item.id} 
                className={`img-wrap ${isStarted ? 'active' : ''}`}
                style={{ transitionDelay: isStarted ? `${index * 150}ms` : '0ms' }}
              >
                <a href={item.permalink} target="_blank" rel="noopener noreferrer">
                  {item.media_type === 'VIDEO' ? (
                    <video src={item.media_url} poster={item.thumbnail_url} autoPlay muted loop playsInline />
                  ) : (
                    <img src={item.media_url} alt={item.caption} loading="lazy" fetchpriority="high" />
                  )}
                  {item.caption && (
                    <div className="caption-overlay">
                      <p className="txt">{item.caption}</p>
                    </div>
                  )}
                </a>
              </div>
            ))}
          </Masonry>
        )}
      </div>
    </section>
  );
}

export default Gallery;